import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import thunk from 'redux-thunk'

import auth from './slices/auth'
import modal from './slices/modal'
import programs from './slices/programs'
import order from './slices/order'

const reducers = combineReducers({
  auth,
  modal,
  programs,
  order
})

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['programs']
}

const persistedReducer = persistReducer(persistConfig, reducers)

export default configureStore({
  reducer: persistedReducer,
  devTools: process.env.REACT_APP_NODE_ENV !== 'production',
  middleware: [thunk]
})
